/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Image_Upload_SuccessInputs */

const vi_product_image_upload_success = /** @type {(inputs: Product_Image_Upload_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải ảnh thành công`)
};

/**

* @param {Product_Image_Upload_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_image_upload_success = /** @type {((inputs?: Product_Image_Upload_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Image_Upload_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_image_upload_success(inputs)
});